import { ApplicationStatus } from 'modules/teams/domain/enums/application-status';
import { StepperMainTool } from 'modules/main/domain/utils/stepper-tool';
import { Pages } from 'modules/navigation/domain/enums/pages';
import { invalidatePlayersList } from 'modules/players/store';
import PlayerForm, { SubmitPlayerForm } from 'modules/players/ui/components/player-form';
import { addPlayerApplication } from 'modules/teams/store/championship-teams';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AppDispatch } from 'store/store';
import { upsertTournamentPlayerApplication } from 'modules/teams/store/players/actions';

interface CreatePlayerProps {
  tournamentId: number;
  teamId: number;
}

const CreatePlayer = (props: CreatePlayerProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const { tournamentId, teamId } = props;
  const [isLoading, setIsLoading] = useState(false);
  const playerId = Number(useLocation().state?.fromPlayer);

  const handleDisableForm = useCallback(() => {
    navigate(Pages.TEAMS.builders.edit(teamId, 'players'), {
      state: { fromPlayer: playerId },
    });
  }, [navigate, playerId, teamId]);

  const handleSubmit = useCallback<SubmitPlayerForm>(
    ({ values, formikHelpers }) => {
      const photo = values.photo && values.photo[0] instanceof File ? (values.photo as File[]) : undefined;
      const height = values.height && !isNaN(Number(values.height)) ? Number(values.height) : undefined;
      const weight = values.weight && !isNaN(Number(values.weight)) ? Number(values.weight) : undefined;

      setIsLoading(true);

      dispatch(
        upsertTournamentPlayerApplication({
          userId: values.id,
          teamId,
          tournamentId,
          name: values.name,
          surname: values.surname,
          middleName: values.middleName,
          birthDate: values.birthDate,
          height,
          weight,
          photo,
        }),
      )
        .unwrap()
        .then((data) => {
          handleDisableForm();
          StepperMainTool.setByPath('stepper:main:createPlayer', true);

          // Игрок создан — список /players устарел. Перечитает его сама страница списка,
          // повторно тянуть user(id) не нужно: upsertTournamentPlayerApplication его уже вернул.
          dispatch(invalidatePlayersList());
          dispatch(
            addPlayerApplication({
              teamId,
              application: {
                teamId,
                player: {
                  id: data.id,
                  firstName: data.name,
                  lastName: data.surname,
                  middleName: data.middleName,
                  birthDate: data.birthDate,
                  height: data.height,
                  weight: data.weight,
                  logoUrl: data.tournamentAvatars?.[0]?.image?.externalUrl,
                },
                status: ApplicationStatus.PENDING,
                id: data.id,
                createdAt: data.createdAt?.toISOString(),
              },
            }),
          );
        })
        .catch((error) => {
          if (error === 'User is already in this team') {
            toast.error('Игрок уже в этой команде');
          } else if (error === 'Tournament user created') {
            toast.error('Такой игрок уже существует');
          } else {
            toast.error('Не удалось выполнить операцию');
          }
        })
        .finally(() => {
          formikHelpers.setSubmitting(false);
          setIsLoading(false);
        });
    },
    [dispatch, handleDisableForm, teamId, tournamentId],
  );

  return (
    <div className="pt-6">
      <PlayerForm onSubmit={handleSubmit} isLoading={isLoading} />
    </div>
  );
};

export default CreatePlayer;
